import { Text, View } from '@react-pdf/renderer';

import IconCheck from './IconCheck';
import IconClose from './IconClose';

export default function PartStateIcon({ isPanorama, isPlastic, paint, state }) {
	const getIconView = (color) => {
		return (
			<View
				style={{
					textAlign: 'center',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
				}}
			>
				{color === 'green' ? <IconCheck /> : <IconClose />}

				<Text
					style={{
						color: '#000',
						fontSize: 8,
						fontWeight: 600,
					}}
				>
					{paint}
				</Text>
			</View>
		);
	};

	if (((isPanorama || isPlastic) && !paint) || paint?.length === 0) {
		return (
			<Text
				style={{
					color: '#000',
					backgroundColor: 'transparent',
					fontSize: 6,
					fontWeight: 'bold',
				}}
			>
				0
			</Text>
		);
	}

	if (state.includes('Перекрас детали', 'Деталь перекрашена') && paint <= 500) {
		return getIconView();
	}

	if (
		(state.includes('OK') && paint > 500) ||
		(!state.includes('OK') && paint > 500)
	) {
		return getIconView('red');
	}

	if (
		(state.includes('OK') && paint <= 500) ||
		(!state.includes('OK') && paint <= 500)
	) {
		return getIconView('green');
	}

	if (!state.includes('OK') && !paint) {
		return <IconClose />;
	}

	return <IconCheck />;
}
